import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "tw:h-7! tw:w-full! tw:min-w-0! tw:rounded-md! tw:border! tw:border-input! tw:bg-input/20! tw:px-2! tw:py-0.5! tw:text-sm! tw:transition-colors! tw:outline-none tw:file:inline-flex! tw:file:h-6! tw:file:border-0! tw:file:bg-transparent! tw:file:text-xs/relaxed! tw:file:font-medium tw:file:text-foreground! tw:placeholder:text-muted-foreground! tw:focus-visible:border-ring! tw:focus-visible:ring-2 tw:focus-visible:ring-ring/30 tw:disabled:pointer-events-none! tw:disabled:cursor-not-allowed! tw:disabled:opacity-50! tw:aria-invalid:border-destructive! tw:aria-invalid:ring-2 tw:aria-invalid:ring-destructive/20 tw:md:text-xs/relaxed! tw:dark:bg-input/30! tw:dark:aria-invalid:border-destructive/50! tw:dark:aria-invalid:ring-destructive/40!",
        className
      )}
      {...props}
    />
  )
}

export { Input }
